/**
 * Pure, testable resolution of the API mode from the raw build-time env value.
 *
 * Kept in its own module (no `import.meta`) so it can be unit-tested under
 * Jest, which cannot parse `import.meta` at module scope.
 *
 * Safety property: a PRODUCTION build must never silently run against a
 * dev backend. 'local' is a dev-only convenience; in a production build any
 * value other than an explicit 'remote' (including unset/unknown) resolves
 * to 'remote'. In a dev build the default is 'local'.
 */
export type ApiMode = 'local' | 'remote';

export function resolveApiMode(rawMode: string | undefined, isDev: boolean): ApiMode {
  if (isDev) {
    if (rawMode === 'local' || rawMode === 'remote') return rawMode;
    return 'local';
  }
  // Production: only an explicit 'remote' is honoured; everything else (unset,
  // 'local', typos) falls back to 'remote' so a misconfigured deploy can never
  // ship pointed at a dev backend.
  return 'remote';
}
